const APIUrl = window.location.origin;
const BasePathUrl = "/lk/auth";
const AUTH_COOKIE = "idsrv.session";
/** OIDC-клиент SPA модуля Auth (для POST Impersonate/Logout/{clientId}). */
const AuthClientId = "module_auth";

export {BasePathUrl, APIUrl, AUTH_COOKIE, AuthClientId};
